import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import { FaWhatsapp } from "react-icons/fa";
import { GoArrowLeft } from "react-icons/go";
import PhoneInput from "react-phone-input-2";
import { MdOutlineContentCopy } from "react-icons/md";

const RichTextModal = ({
  open,
  onClose,
  initialValue = "",
  title = "Editor",
  onCopy,
  setPhone,
  phone,
  editorValue,
  setEditorValue,
  handleWhatsAppShare,
  countryNameToIso,
  userinfo,
  contactInput,
  setContactError,
  setContactInput,
  contactError,
  setSuccessMsg
}) => {
  // const [value, setEditorValue] = useState("");



  useEffect(() => {
    if (open) {
      setEditorValue(initialValue);
    }
  }, [open, initialValue]);

  if (!open) return null;

  return (
    <div className="rtm-overlay">
      <div className="rtm-modal">

        {/* Header */}
        <div className="d-flex justify-content-start align-items-center mb-3">
          <button className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1" onClick={onClose}>
            <GoArrowLeft className="font-size-h4" />
          </button>
          <h5 className="mb-0">{title}</h5>
        </div>

        {/* Editor */}
        <ReactQuill
          theme="snow"
          value={editorValue}
          onChange={setEditorValue}
          modules={{
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link"],
              ["clean"],
            ],
          }}
        />

          <div className="input-group mb-2 mt-4 phone-bootstrap">
              {/* <div className="input-group-prepend">
                  <span className="input-group-text bg-white border-right-0 pl-3 pr-0">
                  <FaWhatsapp className="text-success" size={18} />
                  </span>
              </div> */}

              <PhoneInput
                  country={countryNameToIso(userinfo?.country)}
                  value={contactInput}
                  onChange={(phone) => {
                    setContactInput(phone);
                    setContactError("");
                  }}
                  inputClass="form-control"
                  buttonClass="phone-flag-btn"
                  containerClass="phone-container"
              />
          </div>
          {contactError && (
              <div className="text-danger text-left small mb-3">
                  {contactError}
              </div>
            )}
        {/* Footer */}
        <div className="d-flex justify-content-between mt-3">
          <button
            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm mr-2"
            onClick={() => {
              if (onCopy) onCopy(editorValue);
            }}
          >
            <MdOutlineContentCopy className="mr-2 font-size-h4" />
            Copy Text
          </button>
          <button
            className={`btn btn-sm px-5 btn-primary`}
            onClick={handleWhatsAppShare}
          >
            <FaWhatsapp  className="mr-2 font-size-h4" />
            Share on WhatsApp
          </button>
        </div>

      </div>
    </div>
  );
};

export default RichTextModal;
